import type { Capability } from '@taler/api-client'

/** No dedicated reporting capability exists; these screens read the same aggregate the dashboard does. */
export function canViewReporting(can: (capability: Capability) => boolean): boolean {
  return can('AGGREGATES_VIEW')
}

/** A list of individual money-moving entries, which an aggregates-only role may not read. */
export function canViewLargestTransactions(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_VIEW_ALL')
}
